import { NavLink } from 'react-router-dom';
import { useAuth } from '@contexts/Auth';
import { Pages, pageTitles } from '@/utils/pages';
import { Item, List, Divider, MenuToggle, Nav, Top } from './styled';
import { ReactComponent as Hamburger } from '@/assets/hamburger.svg';
import { ReactComponent as XIcon } from '@/assets/x.svg';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { FAQ_URL } from '@/constants/env';
import { SUPPORT_URL } from '@/constants/env';

const CustomNavLink = ({ path }: { path: string }) => {
  return (
    <NavLink to={path} className={({ isActive }) => (isActive ? 'active' : '')}>
      {pageTitles[path]}
    </NavLink>
  );
};

function Navigation() {
  const [menuActive, setMenuActive] = useState<boolean>(false);
  const { logout, merchantId } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuActive(false);
  }, [pathname]);

  return (
    <Nav data-active={menuActive}>
      <Top>
        <MenuToggle
          onClick={() => setMenuActive(!menuActive)}
          data-active={menuActive}
        >
          {!menuActive ? <Hamburger /> : <XIcon />}
        </MenuToggle>
      </Top>
      <List>
        {merchantId && (
          <Item>
            <CustomNavLink path={Pages.DASHBOARD} />
          </Item>
        )}
        <Item>
          <CustomNavLink path={Pages.EARNINGS} />
        </Item>
        <Item>
          <CustomNavLink path={Pages.SETTINGS} />
        </Item>
        <Item>
          <Divider />
        </Item>
        <Item>
          <a href={FAQ_URL}>FAQs</a>
        </Item>
        <Item>
          <a href={SUPPORT_URL}>Support</a>
        </Item>
        <Item>
          <button onClick={() => logout()}>Log Out</button>
        </Item>
      </List>
    </Nav>
  );
}

export { Navigation };
